var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lightbox',{ref:"lightbox",attrs:{"id":"globallightbox","images":_vm.images}})
}
var staticRenderFns = []

export { render, staticRenderFns }